import { getAmplitudeInstance } from '../amplitudeHelpers';
import AskAllTrailsResponseType from '../enums/AskAllTrailsResponseType';
import CardLocation from '../enums/CardLocation';

type logAskAllTrailsResponseReturnedParams = {
  community_insight_count?: number;
  entry_point?: CardLocation;
  error_reason?: string;
  query_id?: string;
  response_type?: AskAllTrailsResponseType;
  session_id?: string;
  trail_count?: number;
};

/**
 * Ask AllTrails AI response is returned to the user (success or failure).
 * @param params - Attributes to log with the amplitude event
 * @param params.community_insight_count - Number of community insight blocks included in the response. Zero when none or on failure.
 * @param params.entry_point - Surface where the user entered Ask AllTrails.
 * @param params.error_reason - Failure reason when response_status is failure. Omit or leave unset on success.
 * @param params.query_id - Unique id of the query this response corresponds to.
 * @param params.response_type - Whether the AI response succeeded or failed.
 * @param params.session_id - Unique id for a continuous Ask AllTrails session.
 * @param params.trail_count - Number of trails returned in the response. Zero when none or on failure.
 */
const logAskAllTrailsResponseReturned = (
  { community_insight_count, entry_point, error_reason, query_id, response_type, session_id, trail_count }: logAskAllTrailsResponseReturnedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'ask all trails response returned',
    {
      'community insight count': community_insight_count,
      'entry point': entry_point,
      'error reason': error_reason,
      'query id': query_id,
      'response type': response_type,
      'session id': session_id,
      'trail count': trail_count
    },
    callback
  );
};

export default logAskAllTrailsResponseReturned;
